module.exports = new __parcel__URL__("apply_k_faq_expanded_en.668f7650.webp").toString();